import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Subject } from "rxjs";
import { Router } from "@angular/router";

@Component({
  selector: "app-card-request-limit-setting",
  templateUrl: "./card-request-limit-setting.component.html",
  standalone:false,
  styleUrls: ["./card-request-limit-setting.component.scss"],
})
export class CardRequestLimitSettingComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
  CardlimitList: any;
  selectedCardlimit: string = "";

  constructor(private location: Location, private router: Router) {
    this.CardlimitList = [
      {
        iconClass: "",
        displayValue: "Shared limit within primary card",
      },
      {
        iconClass: "",
        displayValue: "Sub limit within primary card",
      },
    ];
  }

  ngOnInit(): void {}
  showModal(num) {
    this.modalObservable.next(num);
  }
  back() {
    this.location.back();
  }
  cardLimitPermanent() {
    this.router.navigateByUrl("/CardLimitPermanent");
  }
  cardRequestPhysicalCard() {
    this.router.navigateByUrl("/CardRequestPhysicalCard");
  }
  onCardlimitChange(event) {
    this.selectedCardlimit = event.displayValue;
  }
}